import * as React from 'react';

function RestartIconComponent(props: any) {
  return (
    <svg
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9198 4C8.76932 4 6.04003 5.81477 4.73723 8.45997H6.45973C7.01201 8.45997 7.45973 8.90769 7.45973 9.45997C7.45973 10.0123 7.01201 10.46 6.45973 10.46H3.30421C3.28828 10.4604 3.27229 10.4604 3.25627 10.46H2.21973C1.66744 10.46 1.21973 10.0123 1.21973 9.45997V5.21997C1.21973 4.66769 1.66744 4.21997 2.21973 4.21997C2.77201 4.21997 3.21973 4.66769 3.21973 5.21997V7.05455C4.93952 4.03133 8.19479 2 11.9198 2C16.4736 2 20.6609 5.31009 21.675 9.77869C21.7972 10.3173 21.4597 10.853 20.9211 10.9752C20.3825 11.0974 19.8468 10.7599 19.7246 10.2213C18.9187 6.66991 15.546 4 11.9198 4ZM17.5398 13.54C16.9875 13.54 16.5398 13.9878 16.5398 14.54C16.5398 15.0923 16.9875 15.54 17.5398 15.54H19.1023C17.7995 18.1852 15.0702 20 11.9198 20C8.29354 20 4.9209 17.3301 4.11497 13.7787C3.99275 13.2401 3.45706 12.9026 2.91846 13.0248C2.37987 13.147 2.04234 13.6827 2.16457 14.2213C3.17864 18.6899 7.366 22 11.9198 22C15.7637 22 19.1074 19.8369 20.7798 16.6529V18.78C20.7798 19.3323 21.2275 19.78 21.7798 19.78C22.3321 19.78 22.7798 19.3323 22.7798 18.78V14.54C22.7798 13.9878 22.3321 13.54 21.7798 13.54H20.5837C20.5674 13.5396 20.5511 13.5396 20.535 13.54H17.5398Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default RestartIconComponent;
